import axios from "axios";
import fileDownload from "js-file-download";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getUserBranches = async (params: any) => {
  const { data } = await axios.get(endpoints.USER_BRANCH, {
    headers: { Authorization: accessToken },
    params,
  });
  return data;
};

const getUserBranch = async (id: number) => {
  const { data } = await axios.get(endpoints.DETAIL_USER_BRANCH(id), {
    headers: { Authorization: accessToken },
  });
  return data;
};

const createUserBranch = async (data: any) => {
  const response = await axios.post(endpoints.USER_BRANCH, data, {
    headers: { Authorization: accessToken },
  });
  return response.data;
};

const updateUserBranch = async ({ id, data }: { id: number; data: any }) => {
  const response = await axios.patch(endpoints.DETAIL_USER_BRANCH(id), data, {
    headers: { Authorization: accessToken },
  });
  return response.data;
};

const deleteUserBranch = async (id: number) => {
  const { data } = await axios.delete(endpoints.DETAIL_USER_BRANCH(id), {
    headers: { Authorization: accessToken },
  });
  return data;
};

const downloadTemplate = async () => {
  const response = await axios.get(endpoints.USER_BRANCH_TEMPLATE, {
    headers: { Authorization: accessToken },
    responseType: "arraybuffer",
  });
  fileDownload(
    new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    "user_branch_template.xlsx"
  );
};

const uploadBulk = async (file: FormData) => {
  const { data } = await axios.post(endpoints.USER_BRANCH_UPLOAD, file, {
    headers: { Authorization: accessToken },
  });
  return data;
};

export default {
  getUserBranches,
  getUserBranch,
  createUserBranch,
  updateUserBranch,
  deleteUserBranch,
  downloadTemplate,
  uploadBulk,
};